import { apiServer } from 'settings/web-services/api';

export function getPartnerById(cfg) {
  return apiServer.get(
    `/partner/partners/${cfg.partnerId}${cfg.IsStrictlyProfile ? '?IsStrictlyProfile=1' : ''}`,
  );
}
